import React, { Component } from 'react';

class InternalServerError extends Component {
  render() {
    return (
      <div
        className="modal fade theme-modal" id="internalServerErrorModal"
        tabIndex="-1" aria-labelledby="internalServerErrorModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>Sorry! We are not able to process your request at this time.
                Please try again after some time.
                If this persists, your WiFi network may be blocking the kplogic.com domain.
                Ask the network admin to add kplogic.com to their whitelist.
                Another option is to turn off WiFi and use cellular data.
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-theme w-100"
                    data-bs-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InternalServerError;
